module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZBAMAAAA2x5hQAAAAJFBMVEX1zlL0zFH/1VX////1zVL66bX88tL313P2z1n99+T++u7435C5HN7OAAAAA3RSTlPtkAbDbqgCAAAAkUlEQVQY02NQZHGBAUYFBhEXBBBgYEHiMTAgcVwcsPDcI42nlsB4HsHGxsamLVBemzEIZEB5QKn0ZGNTCM8dKBECFCkB81yBvGUgETDPE8hKBeIpYJ6zsfFqDyDPBMbL9IbzgCrN3OAqgaaYui2GmQK0wdp9McwGoO2mu4xhtqO5DNXVqD5C8i1quKCGGUp4AgCfbVR8QoBZggAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_app.png
// module id = lgvZ
// module chunks = 1